import { ErrorHandler } from '@angular/core';
import { SentryService } from '../../core/services/sentry.service';
import { environment } from '../../../environments/environment';

export class CustomErrorHandler implements ErrorHandler {
  constructor(private sentryService: SentryService) {}

  handleError(error: Error) {
    if (this.sentryService.isBrowser() && environment?.sentry_enabled) {
      this.sentryService.initSentry().then(t => {
        t.report(error);
      });
    }
    console.error(error); // still output issues
  }
}
